import NearbySelectionScreen from 'features/rewards/screens/NearbyOffers/NearbySelectionScreen';
import React from 'react';

export default function Page() {
  return <NearbySelectionScreen />;
}
